export default "__VITE_ASSET__Cp56Xv26__"